'use client';
import * as LabelPrimitive from '@radix-ui/react-label';
import { labelStyled } from './label.css';
import { ReactNode } from 'react';

export const Label = ({
  children,
  css,
  ...rest
}: {
  children: ReactNode;
  as?: string;
  css?: React.CSSProperties;
}) => {
  return (
    <LabelPrimitive.Root style={css} className={labelStyled} {...rest}>
      {children}
    </LabelPrimitive.Root>
  );
};
